import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { Frame } from '../InlineCard/Frame';
export var CardLinkView = /*#__PURE__*/function (_React$PureComponent) {
  function CardLinkView() {
    _classCallCheck(this, CardLinkView);
    return _callSuper(this, CardLinkView, arguments);
  }
  _inherits(CardLinkView, _React$PureComponent);
  return _createClass(CardLinkView, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Frame, _extends({
        withoutBackground: true
      }, this.props), this.props.placeholder || this.props.link);
    }
  }]);
}(React.PureComponent);